import { Query } from '@farfetched/core';
import { createEvent, EventCallable, sample } from 'effector';
import { ShiftReportRegistryModel } from 'entities/shift';
import { createDownloadShiftReportQuery, DownloadShiftReportQueryParams } from 'shared/api';

export type ExportReportShiftsModel = {
	exportButtonClicked: EventCallable<void>;
	downloadShiftReportQuery: Query<DownloadShiftReportQueryParams, void, unknown, null>;
};

export const createExportReportShiftsModel = (
	model: ShiftReportRegistryModel,
): ExportReportShiftsModel => {
	const downloadShiftReportQuery = createDownloadShiftReportQuery();

	const exportButtonClicked = createEvent();

	sample({
		clock: exportButtonClicked,
		source: model.registryModel.$filters,
		fn: (filters) => filters,
		target: downloadShiftReportQuery.start,
	});

	return {
		downloadShiftReportQuery,
		exportButtonClicked,
	};
};
